/**
 * Identificadores de modelo do OpenRouter.
 *
 * Um id pode vir com sufixo depois de dois-pontos, e há dois casos diferentes
 * que se parecem:
 *
 * - `:free` e `:batch` são **entradas próprias do catálogo** — existem como
 *   modelos listados, com preço e limites próprios.
 * - `:online` é um **modificador de roteamento** aplicável a qualquer modelo, e
 *   não aparece no catálogo em lugar nenhum.
 *
 * Sem distinguir os dois, `google/gemini-2.0-flash-001:online` — que é o
 * estimador de custo em produção — seria marcado como "modelo indisponível" na
 * tela de configurações, um alarme falso sobre algo que funciona.
 */
/** Sufixos que existem como entrada própria no catálogo. */
const SUFIXOS_LISTADOS = ["free", "batch"];
/** `google/gemini-2.5-flash:online` → `google/gemini-2.5-flash` */
export function idBase(id) {
    const corte = id.indexOf(":");
    return corte === -1 ? id : id.slice(0, corte);
}
/** O sufixo, sem os dois-pontos. Vazio quando não há. */
export function sufixoDoModelo(id) {
    const corte = id.indexOf(":");
    return corte === -1 ? "" : id.slice(corte + 1);
}
/**
 * O modelo existe no catálogo?
 *
 * Casa pelo id exato — que cobre `:free` e `:batch` — e, para sufixos que não
 * são listados, pelo id base.
 */
export function modeloExiste(id, catalogo) {
    if (id === "")
        return false;
    if (catalogo.includes(id))
        return true;
    const sufixo = sufixoDoModelo(id);
    if (sufixo === "")
        return false;
    // Sufixo listado que não casou exato é porque aquela variante não existe
    // mesmo — não vale cair para o id base e dizer que está tudo bem.
    if (SUFIXOS_LISTADOS.includes(sufixo))
        return false;
    return catalogo.includes(idBase(id));
}
//# sourceMappingURL=modelos.js.map